import { createApp } from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import notitia from "./plugins/notitia";
import { createPinia } from "pinia";
import { loadFonts } from "./plugins/webfontloader";
import router from "./router";
import "@mdi/font/css/materialdesignicons.css";
import "@lr-notitia/notitia-ui/styles";
import "vuetify/styles";
import "../public/style_overrides.css";
import "flag-icons/css/flag-icons.min.css";

// override some teamly vuetify styles
import "@lr-notitia/teamly/styleOverrides";
import Components from "@lr-notitia/teamly/components";

const app = createApp(App);

// Groupware Vue Components
for (const [key, value] of Object.entries(Components)) {
	app.component(key, value);
}

loadFonts();

app.use(router).use(notitia).use(createPinia()).mount("#app");
